export default __webpack_public_path__ + "static/media/left_bg_two.430ab654.png";